/* eslint-disable */
import Cookies from 'js-cookie';
import { isServerSideRendering } from '../../utilities';

function loadExternalScript(source: string) {
  const firstScript = document.getElementsByTagName('script')[0];
  const element = document.createElement('script');
  element.type = 'text/javascript';
  element.async = true;
  element.src = source;
  firstScript.parentNode?.insertBefore(element, firstScript);
}

function getOsName() {
  let osName = 'Unknown OS';
  if (window.navigator.appVersion.indexOf('Win') !== -1) {
    osName = 'Windows';
  }
  if (window.navigator.appVersion.indexOf('Mac') !== -1) {
    osName = 'MacOS';
  }
  if (window.navigator.appVersion.indexOf('X11') !== -1) {
    osName = 'UNIX';
  }
  if (window.navigator.appVersion.indexOf('Linux') !== -1) {
    osName = 'Linux';
  }
  return osName;
}

function getBrowserName() {
  const useragent = window.navigator.userAgent;
  let matchedName: string[] =
    useragent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(matchedName[1])) {
    const tridentRevision = /\brv[ :]+(\d+)/g.exec(useragent);
    return `IE ${tridentRevision?.[1] || ''}`;
  }
  if (matchedName[1] === 'Chrome') {
    const oprRevision = useragent.match(/\bOPR\/(\d+)/);
    if (oprRevision !== null) {
      return `Opera ${oprRevision[1]}`;
    }
  }
  matchedName = matchedName[2]
    ? [matchedName[1], matchedName[2]]
    : [window.navigator.appName, window.navigator.appVersion, '-?'];
  const versionRevision = useragent.match(/version\/(\d+)/i);
  if (versionRevision !== null) {
    matchedName.splice(1, 1, versionRevision[1]);
  }

  return matchedName.join(' ');
}

function getDynamicProperties() {
  return {
    ipAddress: Cookies.get('CVCurrentIpAddress') || ''
  };
}

const clientProperties = isServerSideRendering
  ? {}
  : {
      browser: getBrowserName(),
      os: getOsName(),
      deviceCategory: window.WURFL && window.WURFL.form_factor,
      deviceName: window.WURFL && window.WURFL.complete_device_name,
      referrer: document.referrer,
      language: navigator.language,
      screenResolution: `${screen.width}x${screen.height}`,
      browserResolution: `${window.innerWidth}x${window.innerHeight}`,
      url: window.location.href,
      carvanaBrowserId: Cookies.get('BrowserCookieId')
    };

class KissMetrics {
  setup() {
    if (isServerSideRendering) return;
    const KissMetricsKey = process.env.CARVANA_APP_KISSMETRICS_KEY;
    window._kmq = window._kmq || [];
    window._kmk = window._kmk || KissMetricsKey;
    setTimeout(() => loadExternalScript('//i.kissmetrics.com/i.js'), 1);
    setTimeout(() => loadExternalScript(`//scripts.kissmetrics.com/${KissMetricsKey}.2.js`), 1);
  }

  trackEvent(name: string, data?: Record<string, unknown>) {
    if (isServerSideRendering) return;

    const dataWithClientProperties = Object.assign(
      {},
      clientProperties,
      getDynamicProperties(),
      data
    );
    window._kmq?.push(['record', name, dataWithClientProperties]);
  }

  identify(identity: string) {
    if (isServerSideRendering) return;

    window._kmq?.push(['identify', identity]);
  }

  clearIdentity() {
    if (isServerSideRendering) return;

    window._kmq?.push(['clearIdentity']);
  }
}

export default new KissMetrics();
